define('drops/dynamicText/dynamicText',[
    'jquery',
    'lq',
    'lq/drop',
    'lq/style',
    'lq/util',
    'lq/richText',
    'lq/html',
    'lq/constants',
    'lq/tooltip',
    'lq/onlongpress'
], function($, lq, Drop, Style, util, richText, html, constants, Tooltip, OnLongPress) {
    'use strict';

    var defaults = {
        data: {
            trimTextWithEllipsis: false,
            useDynamicWidth: true,
            useDynamicHeight: true,
            hideWhenEmpty: false,
            trimTextWithEllipsisMaxNumberOfLines: 1,
            title: {
                option: Tooltip.hardcoded
            },
            role: 'default',
            lineBreakAnywhere: false
        }
    };

    var base = Drop;
    function DynamicText(options) {
        base.call(this, $('<div/>'), defaults, options);

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing) || {};

        this.$element
            .addClass('boxToBorderSize drop-text-container dynamic-text');

        new OnLongPress().applyLongPressOnElement(this.$element, this);

        if (this.data.eventing.clicked && this.data.eventing.clicked.enabled === true) {
            this.$element.addClass('clickable');
        }
        if (this.data.lineBreakAnywhere) {
            this.$element.css({ lineBreak: 'anywhere' });
        }

        this.applyEventTrigger('mouseEnter', 'mouseenter');
        this.applyEventTrigger('mouseLeave', 'mouseleave');
        this.addEventsToBeCanceledAndCanceledBy('mouseEnter', 'mouseLeave');

        this.tooltip = new Tooltip(this, this.data.title, this.$element);
        this.defaultVisible = this.data.initialVisibility;
    };

    base.extend(DynamicText);

    DynamicText.typeName = 'DynamicText';

    DynamicText.prototype.showMockData = function (mockData) {
        this.setValue({ value: this.getMockTextToShow(mockData), type: constants.string });
    };

    DynamicText.prototype.addLoadingIfNeeded = function () {
        if (this.isLoadingStyleEnabled()) {
            this.$element
                .addClass('loading');
        }
    };

    DynamicText.prototype.applyRelativePositioning = function () {
        this.data.isPositionRelative = true;
        if (!this.isLoading()) return;
        var sizeCss = {};

        if (this.data.useDynamicWidth)
            sizeCss.minWidth = this.data.size.x + 'px';
        if (this.data.useDynamicHeight)
            sizeCss.minHeight = this.data.size.y + 'px';

        this.$element.css(sizeCss);
    };

    DynamicText.prototype.isLoading = function () {
        if (this.$element.hasClass('loading'))
            return this.isLoadingStyleEnabled();
        return false;
    };

    DynamicText.prototype.getMockTextToShow = function (mockData) {
        return mockData;
    };

    DynamicText.prototype.updateMockData = function () {
        this.applyPosition();
    };

    DynamicText.prototype.show = function (isBasedOnHideWhenEmpty) {
        if (!this.data.hideWhenEmpty) {
            Drop.prototype.show.call(this);
            return;
        }

        if (!isBasedOnHideWhenEmpty)
            this.defaultVisible = true;
        if (isBasedOnHideWhenEmpty)
            this.hideWhenEmptyVisible = true;
        if (this.defaultVisible && this.hideWhenEmptyVisible)
            Drop.prototype.show.call(this);
    };

    DynamicText.prototype.hide = function (isBasedOnHideWhenEmpty) {
        if (!this.data.hideWhenEmpty) {
            Drop.prototype.hide.call(this);
            return;
        }

        if (!isBasedOnHideWhenEmpty)
            this.defaultVisible = false;
        if (isBasedOnHideWhenEmpty)
            this.hideWhenEmptyVisible = false;
        Drop.prototype.hide.call(this);
    };

    DynamicText.prototype.preRender = function () {
        this.addLoadingIfNeeded();
        this.tooltip.update();

        this.piping.visibility.apply(this);
        this.formatter = this.piping.formatting.createFormatter(this.data.formatting);

        if (!this.data.hideWhenEmpty)
            this.showPlainText();
        else {
            this.hide(true);
        }

        if (this.data.mockData)
            this.showMockData(this.data.mockData);

        if (this.data.containImages) {
            this.$element.addClass('contain-content');
        }

        if (this.data.removeMarginAndPadding) {
            this.$element.addClass('remove-margin-and-padding');
        }

        this.applyPosition();
    };

    DynamicText.prototype.clearValue = function () {
        if (this.data.hideWhenEmpty)
            this.hide(true);
        else {
            if (this.$label)
                this.$label.text('');
            else
                this.richTextEditor.fromString('');
        }
    };

    DynamicText.prototype.rerenderLabel = function () {
        var text = this.text;

        if (this.data.renderAsHtml) {
            if (text) {
                var regex = new RegExp('{{{TenantUrl}}}', 'g');
                text = text.replace(regex, lq.getTenantUrl(''));
            }

            // The attribute used for html events must survive sanitizing, for this drop only
            var sanitizeOptions = this.data.useHtmlEvents && this.data.attributeForHtmlEvent
                ? { allowedAttributes: [this.data.attributeForHtmlEvent] }
                : null;

            var $htmlWrapper = $('<div/>')
                .html(html.sanitize(text, sanitizeOptions) || '');

            this.attachHtmlEventsIfEnabled($htmlWrapper);

            this.$label
                .empty()
                .append($htmlWrapper)
                .css({
                    whiteSpace: 'normal',
                    overflowWrap: 'break-word'
                });
        } else {
            if (this.data.stripHtml && text)
                text = html.strip(text);

            this.$label
                .text(text || '')
                .css({
                    whiteSpace: 'pre-wrap',
                    overflowWrap: 'break-word'
                });
        }

        if (this.data.useValueAsId) {
            this.createDataTarget(text);
        }

        if (this.data.role === 'link') {
            this.createDataTargeter(text);
        }

        if (this.data.trimTextWithEllipsis &&
            (!this.data.title ||
            this.data.title.option === Tooltip.hardcoded &&
            !this.data.title.hardcodedTooltip))
            this.tooltip.update(text);

        if (this.data.hideWhenEmpty) {
            if (text === null || text === undefined || text === '') {
                this.hide(true);
            } else {
                this.show(true);
            }
        }
    };

    DynamicText.prototype.createDataTarget = function (text) {
        var id = this.sanitizeTextForUseAsId(text);
        if (!id) return;

        this.$element.attr('id', id);
        // Attach a data attribute with the same id,
        // used for tracking whether a listitem containing this drop is in view in its parent list [list.js: trackListItemsInView()]
        this.$element.attr('data-target', id);

    };

    DynamicText.prototype.createDataTargeter = function (text) {
        var id = this.sanitizeTextForUseAsId(text);
        if (!id) return;

        this.$element.attr('data-targeter', '#' + id);
        this.$label.attr('href', '#' + id);
    }

    DynamicText.prototype.sanitizeTextForUseAsId = function (value) {
        if (value)
            return value.replace(/ /g, "_");
    };

    DynamicText.prototype.setValue = function (update) {
        this.$element
            .removeClass('loading');

        update.value = update.value === null || update.value === undefined || update.value === '' ? this.data.defaultValue : update.value;

        if (richText.isRichTextString(update.value)) {
            this.hidePlainText();
            this.showRichText();
            this.richTextEditor.fromString(update.value);
            this.show(true);
        } else {
            this.hideRichText();
            this.showPlainText();

            this.text = this.formatter.convertFromLicquidFormat(update.type, update.value);
            this.rerenderLabel();
        }
        this.applyPosition();
    };

    // backwards compatibility
    DynamicText.prototype.getValue = function () {
        if (this.$label)
            return this.$label.text();
        return null;
    };

    DynamicText.prototype.hideRichText = function () {
        if (this.richTextEditor) {
            this.richTextEditor.close();
            this.richTextEditor = null;
        }
    };

    DynamicText.prototype.hidePlainText = function () {
        if (this.$label) {
            this.$label.remove();
            this.$label = null;
        }
    };

    DynamicText.prototype.showRichText = function () {
        if (!this.richTextEditor) {
            this.richTextEditor = new richText.RichTextEditor({
                parentElement: this.$element,
                sections: this.data.sections,
                editable: false
            });

            this.renderStyles();
        }
    };

    DynamicText.prototype.renderStyles = function () {
        if (this.richTextEditor) {
            Style.renderStyles(this, null, this.richTextEditor.$element);
        } else {
            Style.renderStyles(this, null, this.$element);
        }
    };

    DynamicText.prototype.createLabelElement = function () {
        switch (this.data.role) {
            case 'title':
                return $('<h1 />').addClass('ignore-default-headings');
            case 'subtitle':
                return $('<h2 />').addClass('ignore-default-headings');
            case 'label':
                return $('<label />').attr('for', this.rootDrop.instanceId + '_' + this.data.labelForDropId);
            case 'link':
                return $('<a />').css({ color: 'inherit', textDecoration: 'inherit '})
            default:
                return $('<div />');
        }
    };

    DynamicText.prototype.showPlainText = function () {
        if (!this.$label) {

            if (this.data.trimTextWithEllipsis
                && !this.data.trimTextWithEllipsisBasedOnLineCount
                && ((!this.data.useDynamicHeight || !this.data.useDynamicWidth) || !this.isLoading())) {
                this.$labelWrapper = $('<div />')
                    .addClass('ellipsis')
                    .addClass('boxToBorderSize')
                    .css({
                        width: '100%',
                        height: '100%'
                    })
                    .appendTo(this.$element);

                this.$innerLabelWrapper = $('<div />')
                    .appendTo(this.$labelWrapper);

                this.$label = this.createLabelElement()
                    .addClass('drop-text-content')
                    .css({
                        whiteSpace: 'pre-wrap',
                        marginRight: '10px',
                        margin: '0'
                    })
                    .appendTo(this.$innerLabelWrapper);
            } else {
                this.$overflowWrapper = $('<div />')
                    .addClass('overflow-wrapper')
                    .appendTo(this.$element);

                this.$labelWrapper = $('<div />')
                    .css({
                        display: 'flex',
                        width: '100%',
                        height: '100%'
                    })
                    .appendTo(this.$overflowWrapper);

                this.$label = this.createLabelElement()
                    .addClass('boxToBorderSize drop-text-content')
                    .css({
                        display: 'flex',
                        flexDirection: 'column',
                        flex: '1 1 100%',
                        // if not set to flex-start,
                        // and the text is to high
                        // the content will be hidden at the top of the $element
                        justifyContent: this.data.showScrollbar ? 'flex-start' : '',
                        width: '100%',
                        height: '100%'
                    })
                    .appendTo(this.$labelWrapper);

                if (this.data.trimTextWithEllipsis && this.data.trimTextWithEllipsisBasedOnLineCount) {
                    this.$label = this.createLabelElement()
                        .css({
                            overflow: 'hidden',
                            display: '-webkit-box',
                            '-webkit-line-clamp': this.data.trimTextWithEllipsisMaxNumberOfLines.toString(),
                            '-webkit-box-orient': 'vertical',
                            width: '100%'
                        })
                        .appendTo(this.$label);
                }

                if (this.data.showScrollbar) {
                    this.$element.css({
                        overflowY: 'auto',
                        overflowX: 'hidden'
                    });
                }
            }

            this.renderStyles();
        }
    };

    DynamicText.prototype.attachHtmlEventsIfEnabled = function ($htmlWrapper) {
        if (!this.data.useHtmlEvents) return;

        var self = this;
        var $htmlElements = $htmlWrapper.find(this.data.tagForHtmlEvent);

        if (this.isEventEnabled('onHtmlElementClicked')) {
            $htmlElements
                .on('click', function (e) {
                    e.stopPropagation();

                    var eventArgValue;
                    if (self.data.attributeForHtmlEvent)
                        eventArgValue = $(this).attr(self.data.attributeForHtmlEvent);
                    else
                        eventArgValue = $(this).html()

                    self.triggerEvent(self.data.eventing.onHtmlElementClicked.raisedEventName, eventArgValue);
                });
        }

        if (this.isEventEnabled('onHtmlElementMouseEntered') || this.isEventEnabled('onHtmlElementMouseLeft')) {
            $htmlElements
                .on('mouseenter', function () {
                    var eventArgValue = self.data.attributeForHtmlEvent
                        ? $(this).attr(self.data.attributeForHtmlEvent)
                        : $(this).html();

                    self.triggerEventIfEnabled(self.data.eventing.onHtmlElementMouseEntered.raisedEventName, eventArgValue);
                })
                .on('mouseleave', function () {
                    self.triggerEventIfEnabled(self.data.eventing.onHtmlElementMouseLeft.raisedEventName);
                });
        }
    };

    DynamicText.prototype.rerenderDynamicText = function () {
        this.$element.empty();
        this.$label = null;
        this.showPlainText();
        this.rerenderLabel();
    };

    return DynamicText;
});
